import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/imgs/icon/icon12.png';
import _imports_1 from '../../assets/imgs/icon/icon23.png';
const _withScopeId = n => (_pushScopeId("data-v-47618462"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ml50 mt20 pr50 pb50"
};
const _hoisted_2 = {
  class: "step flex_FSC"
};
const _hoisted_3 = {
  class: "section mt15"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", {
  class: "sub_title text_blue"
}, "您的货物正在等待车辆装载", -1));
const _hoisted_5 = {
  class: "order_step_desc"
};
const _hoisted_6 = {
  class: "mt40 flex_FCAC"
};
const _hoisted_7 = {
  key: 0,
  src: _imports_0
};
const _hoisted_8 = {
  key: 1,
  src: _imports_1
};
const _hoisted_9 = {
  class: "mt5"
};
const _hoisted_10 = {
  class: "section mt15"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", {
  class: "title"
}, "运单信息", -1));
const _hoisted_12 = {
  class: "sub_title mt10"
};
const _hoisted_13 = {
  class: "flex mt10 text"
};
const _hoisted_14 = {
  class: "text_grey mr85 flex_FSC"
};
const _hoisted_15 = {
  class: "text_blue"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "mt10 text"
}, "装卸货地址：", -1));
const _hoisted_17 = {
  class: "mt10 flex_FSBS"
};
const _hoisted_18 = {
  class: "flex_FSBC mr50"
};
const _hoisted_19 = {
  class: "flex_FSBS mb10"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dot"
}, "装", -1));
const _hoisted_21 = {
  class: "flex_size_1"
};
const _hoisted_22 = {
  class: "mb5"
};
const _hoisted_23 = {
  class: "ml100"
};
const _hoisted_24 = {
  class: "flex_FSBS mb10"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dot bg_red"
}, "卸", -1));
const _hoisted_26 = {
  class: "flex_size_1"
};
const _hoisted_27 = {
  class: "mb5"
};
const _hoisted_28 = {
  class: "router flex_FSC"
};
const _hoisted_29 = {
  class: "pl15"
};
const _hoisted_30 = {
  class: "section mt15 flex_FSC flex_FS"
};
const _hoisted_31 = {
  class: "mt5"
};
const _hoisted_32 = {
  class: "text_blue sub_title"
};
const _hoisted_33 = {
  class: "mt15 flex_FSC text_blue"
};
const _hoisted_34 = {
  class: "ml5 sub_title"
};
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text pl5"
}, "单", -1));
const _hoisted_36 = {
  class: "ml60"
};
const _hoisted_37 = {
  class: "flex_FSC sub_title"
};
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "mr5 text_orange"
}, "信用", -1));
const _hoisted_39 = {
  class: "mt10 flex_FSC"
};
const _hoisted_40 = {
  class: "ml5 sub_title"
};
const _hoisted_41 = {
  class: "ml60 mt5"
};
const _hoisted_42 = {
  class: "sub_title"
};
const _hoisted_43 = {
  class: "section mt15"
};
const _hoisted_44 = {
  class: "title"
};
const _hoisted_45 = {
  class: "car_info mt10 flex_FSBC"
};
const _hoisted_46 = {
  class: "flex_size_1"
};
const _hoisted_47 = {
  class: "flex_size_1"
};
const _hoisted_48 = {
  class: "flex_size_1"
};
const _hoisted_49 = {
  class: "section mt15"
};
const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", {
  class: "title"
}, "车货信息", -1));
const _hoisted_51 = {
  class: "car_info mt10 flex_FSBC"
};
const _hoisted_52 = {
  class: "flex_size_1"
};
const _hoisted_53 = {
  class: "flex_size_1"
};
const _hoisted_54 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "flex_size_1"
}, null, -1));
const _hoisted_55 = {
  class: "mt30 text text_grey"
};
const _hoisted_56 = {
  class: "section mt15"
};
const _hoisted_57 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", {
  class: "title"
}, "运费信息", -1));
const _hoisted_58 = {
  class: "mt10 flex_FSBC"
};
const _hoisted_59 = {
  class: "mt15 flex_FSC text_blue flex_size_1"
};
const _hoisted_60 = {
  class: "ml5 sub_title"
};
const _hoisted_61 = {
  class: "text pl5"
};
const _hoisted_62 = {
  class: "mt15 flex_FSC text_blue flex_size_1"
};
const _hoisted_63 = {
  class: "ml5 sub_title"
};
const _hoisted_64 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text pl5"
}, "元", -1));
const _hoisted_65 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "flex_size_1"
}, null, -1));
const _hoisted_66 = {
  key: 0,
  class: "section mt15"
};
const _hoisted_67 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", {
  class: "title"
}, "合同信息", -1));
const _hoisted_68 = {
  class: "mt10"
};
const _hoisted_69 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "sub_title"
}, "货物运输合同", -1));
const _hoisted_70 = {
  key: 1,
  class: "section mt15"
};
const _hoisted_71 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", {
  class: "title"
}, "装货详情", -1));
const _hoisted_72 = {
  class: "mt10 flex_FSC flex_FS"
};
const _hoisted_73 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "mr20 sub_title"
}, "装货榜单", -1));
const _hoisted_74 = {
  class: "flex_FCLW flex_size_1 imgbox"
};
const _hoisted_75 = {
  key: 2,
  class: "section mt15"
};
const _hoisted_76 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", {
  class: "title"
}, "卸货详情", -1));
const _hoisted_77 = {
  class: "mt10 flex_FSC flex_FS"
};
const _hoisted_78 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "mr20 sub_title"
}, "卸货榜单", -1));
const _hoisted_79 = {
  class: "flex_FCLW flex_size_1 imgbox"
};
const _hoisted_80 = {
  class: "flex_FCAC mt100"
};
const _hoisted_81 = {
  key: 0,
  class: "btn"
};
const _hoisted_82 = ["disabled"];
const _hoisted_83 = {
  key: 3,
  class: "btn",
  disabled: ""
};
const _hoisted_84 = {
  key: 4,
  class: "btn",
  disabled: ""
};
const _hoisted_85 = {
  key: 0,
  class: "btn"
};
const _hoisted_86 = {
  key: 0,
  class: "btn"
};
const _hoisted_87 = {
  class: "flex_FEC"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Clock = _resolveComponent("Clock");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_text = _resolveComponent("el-text");
  const _component_Location = _resolveComponent("Location");
  const _component_el_tag = _resolveComponent("el-tag");
  const _component_el_rate = _resolveComponent("el-rate");
  const _component_el_button = _resolveComponent("el-button");
  const _component_ArrowRight = _resolveComponent("ArrowRight");
  const _component_el_image = _resolveComponent("el-image");
  const _component_el_popconfirm = _resolveComponent("el-popconfirm");
  const _component_ViewRouter = _resolveComponent("ViewRouter");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.orderInfo?.statusList, (item, index) => {
    return _openBlock(), _createElementBlock("p", {
      class: _normalizeClass([($setup.data.orderInfo?.statusList || []).length - 1 == index && 'active']),
      key: index
    }, _toDisplayString($setup.orderStatusList[item.nowStatus]), 3);
  }), 128))]), _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", {
    class: _normalizeClass(['order_step_contain', !$setup.data.isExpend && '_hidden'])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.orderInfo?.statusList || [], (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "mt10 flex_FSBC order_step text",
      key: index
    }, [_createElementVNode("p", null, _toDisplayString($setup.moment(item.createTime).format("YYYY-MM-DD HH:mm")), 1), _createElementVNode("p", _hoisted_5, _toDisplayString($setup.orderStepDesc(item.nowStatus, $setup.data.orderInfo?.customerInfo?.customerName, $setup.data.orderInfo?.customerInfo?.customerPhone, $setup.data.orderInfo?.vehicleNo)), 1)]);
  }), 128))], 2), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
    class: "pointer flex_FCAC flex_column",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.setIsExpend && $setup.setIsExpend(...args))
  }, [$setup.data.isExpend ? (_openBlock(), _createElementBlock("img", _hoisted_7)) : (_openBlock(), _createElementBlock("img", _hoisted_8)), _createElementVNode("p", _hoisted_9, _toDisplayString($setup.data.isExpend ? "收起" : "展开"), 1)])])]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("p", _hoisted_12, "运单号：" + _toDisplayString($setup.data.orderInfo?.orderNo), 1), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createVNode(_component_el_icon, {
    class: "mr5"
  }, {
    default: _withCtx(() => [_createVNode(_component_Clock)]),
    _: 1
  }), _createElementVNode("p", null, "预装货时间：" + _toDisplayString($setup.data.orderInfo?.loadingInfo?.loadingTime), 1)]), _createElementVNode("p", _hoisted_15, " 创建时间：" + _toDisplayString($setup.moment($setup.data.orderInfo?.createTime).format("YYYY-MM-DD HH:mm")), 1)]), _hoisted_16, _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("ul", null, [_createElementVNode("li", _hoisted_19, [_hoisted_20, _createElementVNode("div", _hoisted_21, [_createElementVNode("p", _hoisted_22, _toDisplayString($setup.data.orderInfo?.loadingInfo?.loadingProvince) + _toDisplayString($setup.data.orderInfo?.loadingInfo?.loadingCity) + _toDisplayString($setup.data.orderInfo?.loadingInfo?.loadingDistrict), 1), _createVNode(_component_el_text, null, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.data.orderInfo?.loadingInfo?.loadingAddress), 1)]),
    _: 1
  })])])]), _createElementVNode("ul", _hoisted_23, [_createElementVNode("li", _hoisted_24, [_hoisted_25, _createElementVNode("div", _hoisted_26, [_createElementVNode("p", _hoisted_27, _toDisplayString($setup.data.orderInfo?.loadingInfo?.unloadingProvince) + _toDisplayString($setup.data.orderInfo?.loadingInfo?.unloadingCity) + _toDisplayString($setup.data.orderInfo?.loadingInfo?.unloadingDistrict), 1), _createVNode(_component_el_text, null, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.data.orderInfo?.loadingInfo?.unloadingAddress), 1)]),
    _: 1
  })])])])])]), _createElementVNode("div", _hoisted_28, [_createElementVNode("p", _hoisted_29, [_createTextVNode(" 预估运输里程 " + _toDisplayString($setup.data.orderInfo?.loadingInfo?.distance) + "KM ", 1), _createElementVNode("span", {
    class: "pointer text_blue pl200",
    onClick: _cache[1] || (_cache[1] = $event => $setup.data.dialogVisible = true)
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_Location)]),
    _: 1
  }), _createTextVNode("查看路线")])])])]), _createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_createElementVNode("p", _hoisted_32, " 承运人：" + _toDisplayString($setup.phoneDesc($setup.data.orderInfo?.customerInfo?.customerName)), 1), _createElementVNode("div", _hoisted_33, [_createVNode(_component_el_tag, {
    type: "primary"
  }, {
    default: _withCtx(() => [_createTextVNode("抢单数")]),
    _: 1
  }), _createElementVNode("p", _hoisted_34, [_createTextVNode(_toDisplayString($setup.data.orderInfo?.customerInfo?.demandNum), 1), _hoisted_35])])]), _createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_hoisted_38, _createVNode(_component_el_rate, {
    modelValue: $setup.data.customerStar,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $setup.data.customerStar = $event),
    disabled: "",
    "allow-half": ""
  }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_39, [_createVNode(_component_el_tag, {
    effect: "plain",
    type: "success"
  }, {
    default: _withCtx(() => [_createTextVNode("好评率")]),
    _: 1
  }), _createElementVNode("p", _hoisted_40, _toDisplayString($setup.data.orderInfo?.customerInfo?.goodRate) + "% ", 1)])]), _createElementVNode("div", _hoisted_41, [_createElementVNode("p", _hoisted_42, "承运车辆：" + _toDisplayString($setup.data.orderInfo?.vehicleNo), 1), _createVNode(_component_el_button, {
    class: "mt15",
    type: "primary",
    onClick: _cache[3] || (_cache[3] = () => $setup.viewProfile())
  }, {
    default: _withCtx(() => [_createTextVNode(" 查看")]),
    _: 1
  })])]), _createElementVNode("div", _hoisted_43, [_createElementVNode("b", _hoisted_44, [_createTextVNode("承运人收款账户 "), _createVNode(_component_el_button, {
    class: "ml20",
    type: "success",
    onClick: _cache[4] || (_cache[4] = () => $setup.copy()),
    disabled: !$setup.data.orderInfo?.driverCardInfo?.personName
  }, {
    default: _withCtx(() => [_createTextVNode(" 复制 ")]),
    _: 1
  }, 8, ["disabled"])]), _createElementVNode("div", _hoisted_45, [_createElementVNode("p", _hoisted_46, " 姓名：" + _toDisplayString($setup.data.orderInfo?.driverCardInfo?.personName), 1), _createElementVNode("p", _hoisted_47, " 卡号： " + _toDisplayString($setup.data.orderInfo?.driverCardInfo?.cardNo), 1), _createElementVNode("p", _hoisted_48, " 银行：" + _toDisplayString($setup.data.orderInfo?.driverCardInfo?.bankName), 1)])]), _createElementVNode("div", _hoisted_49, [_hoisted_50, _createElementVNode("div", _hoisted_51, [_createElementVNode("p", _hoisted_52, " 车辆：" + _toDisplayString(($setup.data.orderInfo?.carGoodsInfo?.carLengthList || []).join("、")) + "/" + _toDisplayString(($setup.data.orderInfo?.carGoodsInfo?.carModelList || []).join("、")), 1), _createElementVNode("p", _hoisted_53, " 货物：" + _toDisplayString($setup.data.orderInfo?.carGoodsInfo?.goodsName) + " " + _toDisplayString($setup.data.orderInfo?.carGoodsInfo?.weight / 100) + _toDisplayString($setup.data.orderInfo?.carGoodsInfo?.unitType == 2 ? "吨" : $setup.freightUnitTypeMap[$setup.data.orderInfo?.carGoodsInfo?.unitType || 0].text) + " " + _toDisplayString($setup.data.orderInfo?.carGoodsInfo?.packageName), 1), _hoisted_54]), _createElementVNode("p", _hoisted_55, " 备注：" + _toDisplayString($setup.data.orderInfo?.carGoodsInfo?.remark), 1)]), _createElementVNode("div", _hoisted_56, [_hoisted_57, _createElementVNode("div", _hoisted_58, [_createElementVNode("div", _hoisted_59, [_createVNode(_component_el_tag, {
    type: "primary"
  }, {
    default: _withCtx(() => [_createTextVNode("总运费")]),
    _: 1
  }), _createElementVNode("p", _hoisted_60, [_createTextVNode(_toDisplayString($setup.data.orderInfo?.amountInfo?.amount / 100), 1), _createElementVNode("span", _hoisted_61, "元/" + _toDisplayString($setup.freightUnitTypeMap[$setup.data.orderInfo?.carGoodsInfo?.unitType || 0].text), 1)])]), _createElementVNode("div", _hoisted_62, [_createVNode(_component_el_tag, {
    type: "primary"
  }, {
    default: _withCtx(() => [_createTextVNode("承运人净得")]),
    _: 1
  }), _createElementVNode("p", _hoisted_63, [_createTextVNode(_toDisplayString($setup.data.orderInfo?.amountInfo?.driverAmount / 100), 1), _hoisted_64])]), _hoisted_65])]), $setup.data.orderInfo?.contractInfo?.contractId ? (_openBlock(), _createElementBlock("div", _hoisted_66, [_hoisted_67, _createElementVNode("div", _hoisted_68, [_hoisted_69, _createVNode(_component_el_button, {
    text: "",
    type: "primary",
    size: "large",
    onClick: _cache[5] || (_cache[5] = () => $setup.toViewContract())
  }, {
    default: _withCtx(() => [_createTextVNode(" 去查看"), _createVNode(_component_el_icon, {
      class: "el-icon--right"
    }, {
      default: _withCtx(() => [_createVNode(_component_ArrowRight)]),
      _: 1
    })]),
    _: 1
  })])])) : _createCommentVNode("", true), ($setup.data.orderInfo?.loadingInfo?.loadingPic ?? []).length ? (_openBlock(), _createElementBlock("div", _hoisted_70, [_hoisted_71, _createElementVNode("div", _hoisted_72, [_hoisted_73, _createElementVNode("div", _hoisted_74, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.orderInfo?.loadingInfo?.loadingPic, (item, index) => {
    return _openBlock(), _createBlock(_component_el_image, {
      key: index,
      style: {
        "width": "10vw",
        "height": "10vw"
      },
      class: "mr10 mb10",
      src: item,
      "zoom-rate": 1.2,
      "max-scale": 7,
      "min-scale": 0.2,
      "preview-src-list": $setup.data.orderInfo?.loadingInfo?.loadingPic,
      "show-progress": "",
      "initial-index": index,
      fit: "cover"
    }, null, 8, ["src", "preview-src-list", "initial-index"]);
  }), 128))])])])) : _createCommentVNode("", true), ($setup.data.orderInfo?.loadingInfo?.unloadingPic ?? []).length ? (_openBlock(), _createElementBlock("div", _hoisted_75, [_hoisted_76, _createElementVNode("div", _hoisted_77, [_hoisted_78, _createElementVNode("div", _hoisted_79, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.orderInfo?.loadingInfo?.unloadingPic, (item, index) => {
    return _openBlock(), _createBlock(_component_el_image, {
      key: index,
      style: {
        "width": "10vw",
        "height": "10vw"
      },
      class: "mr10 mb10",
      src: item,
      "zoom-rate": 1.2,
      "max-scale": 7,
      "min-scale": 0.2,
      "preview-src-list": $setup.data.orderInfo?.loadingInfo?.unloadingPic,
      "show-progress": "",
      "initial-index": index,
      fit: "cover"
    }, null, 8, ["src", "preview-src-list", "initial-index"]);
  }), 128))])])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_80, [[0, 1, 2, 3, 4, 5, 9].includes($setup.data.orderInfo?.status) ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "btn",
    onClick: _cache[6] || (_cache[6] = () => $setup.contact())
  }, " 联系承运人 ")) : _createCommentVNode("", true), _createVNode(_component_el_popconfirm, {
    title: "确定取消订单?",
    "confirm-button-text": "确定",
    "cancel-button-text": "取消",
    onConfirm: _cache[7] || (_cache[7] = () => $setup.cancelOrder())
  }, {
    reference: _withCtx(() => [[0, 1].includes($setup.data.orderInfo?.status) ? (_openBlock(), _createElementBlock("div", _hoisted_81, " 取消订单 ")) : _createCommentVNode("", true)]),
    _: 1
  }), $setup.data.orderInfo?.status == 0 ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "btn",
    disabled: $setup.data.orderInfo?.isSign,
    onClick: _cache[8] || (_cache[8] = () => $setup.sign())
  }, _toDisplayString($setup.data.orderInfo?.isSign ? "已签约" : "我要签约"), 9, _hoisted_82)) : _createCommentVNode("", true), $setup.data.orderInfo?.status == 9 && !$setup.data.orderInfo?.forwarderInvoice && !$setup.data.orderInfo?.driverInvoice && $setup.data.orderInfo?.hasInvoice ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: "btn",
    onClick: _cache[9] || (_cache[9] = () => $setup.invoice())
  }, " 确认结算 ")) : _createCommentVNode("", true), $setup.data.orderInfo?.status == 9 && $setup.data.orderInfo?.forwarderInvoice == 1 && !$setup.data.orderInfo?.driverInvoice ? (_openBlock(), _createElementBlock("div", _hoisted_83, " 待承运人确认开票 ")) : _createCommentVNode("", true), $setup.data.orderInfo?.status == 9 && $setup.data.orderInfo?.forwarderInvoice == 1 && $setup.data.orderInfo?.driverInvoice == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_84, " 已开票 ")) : _createCommentVNode("", true), _createVNode(_component_el_popconfirm, {
    title: "同意取消该订单吗?",
    "confirm-button-text": "确定",
    "cancel-button-text": "取消",
    onConfirm: _cache[10] || (_cache[10] = () => $setup.agreeCancelOrder(1))
  }, {
    reference: _withCtx(() => [$setup.data.orderInfo?.status == 5 ? (_openBlock(), _createElementBlock("div", _hoisted_85, "同意取消")) : _createCommentVNode("", true)]),
    _: 1
  }), _createVNode(_component_el_popconfirm, {
    title: "拒绝取消该订单吗?",
    "confirm-button-text": "确定",
    "cancel-button-text": "取消",
    onConfirm: _cache[11] || (_cache[11] = () => $setup.agreeCancelOrder(0))
  }, {
    reference: _withCtx(() => [$setup.data.orderInfo?.status == 5 ? (_openBlock(), _createElementBlock("div", _hoisted_86, "拒绝取消")) : _createCommentVNode("", true)]),
    _: 1
  }), ($setup.data.orderInfo?.status == 9 || $setup.data.orderInfo?.status == 10) && !$setup.data.orderInfo?.isEvaluation ? (_openBlock(), _createElementBlock("div", {
    key: 5,
    class: "btn",
    onClick: _cache[12] || (_cache[12] = () => $setup.toEvaluate())
  }, " 去评价 ")) : _createCommentVNode("", true), ($setup.data.orderInfo?.status == 9 || $setup.data.orderInfo?.status == 10) && $setup.data.orderInfo?.isEvaluation ? (_openBlock(), _createElementBlock("div", {
    key: 6,
    class: "btn",
    onClick: _cache[13] || (_cache[13] = () => $setup.viewProfile())
  }, " 查看评价 ")) : _createCommentVNode("", true)])]), _createVNode(_component_el_dialog, {
    modelValue: $setup.data.dialogVisible,
    "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $setup.data.dialogVisible = $event),
    title: "查看路线",
    fullscreen: "",
    center: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_ViewRouter, {
      origin: $setup.data.origin,
      destination: $setup.data.destination
    }, null, 8, ["origin", "destination"])]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
    style: {
      "width": "60vw",
      "height": "95vh",
      "overflow": "hidden",
      "overflow-y": "auto"
    },
    top: "2.5vh",
    center: "",
    modelValue: $setup.dialog.visible,
    "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => $setup.dialog.visible = $event),
    "show-close": false
  }, {
    header: _withCtx(() => [_createElementVNode("div", _hoisted_87, [_createVNode(_component_el_button, {
      type: "primary",
      onClick: _cache[15] || (_cache[15] = () => $setup.handleContractSign())
    }, {
      default: _withCtx(() => [_createTextVNode(" 签约 ")]),
      _: 1
    })])]),
    default: _withCtx(() => [_createVNode(_component_el_image, {
      src: 'data:image/png;base64,' + $setup.dialog.contractInfo?.contract,
      fit: "contain"
    }, null, 8, ["src"])]),
    _: 1
  }, 8, ["modelValue"])], 64);
}